import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './XLindex.css';

const XLindex: React.FC = () => {
  return (
    <div className="xl-container">
      <Header />

      <section id="home" className="xl-hero" style={ {backgroundImage: `url(${process.env.PUBLIC_URL}/image/main-20260518.png)`} }>
        {/*<div className="xl-hero-overlay"></div>*/}
        <div className="xl-hero-content">
          <p className="xl-hero-text">
            在这里，我们为您提供专业的AI生产力方案，这些创新的服务帮助您提升效率和质量。
          </p>
          <div className="xl-hero-buttons">
            <a href="/products" className="xl-btn xl-btn-primary">了解更多</a>
            <a href="/contact" className="xl-btn xl-btn-secondary">联系我们</a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="products" className="xl-services">
        <div className="xl-services-inner">
          <div className="xl-service-card">
            <div className="xl-star">★</div>
            <h3>AI客服解决方案</h3>
            <p>
              我们的AI客服解决方案能够提供全方位的优质服务，覆盖AI客服机器人、人工坐席工作台、呼叫中心等，帮助提升客户体验，节省人力成本。
            </p>
            <button className="xl-btn xl-btn-outline">了解更多</button>
          </div>
          <div className="xl-service-card">
            <div className="xl-star">★</div>
            <h3>AI医疗解决方案</h3>
            <p>
              我们提供精准可控的智能医疗解决方案，帮助医生高质量的诊疗和高效的服务患者，时刻帮助患者解决问题。
            </p>
            <button className="xl-btn xl-btn-outline">了解更多</button>
          </div>
          <div className="xl-service-card">
            <div className="xl-star">★</div>
            <h3>AI生产力平台</h3>
            <p>
              我们的AI生产力平台能够为业务带来价值的生产力提升，提供高性能的智能能力。
            </p>
            <button className="xl-btn xl-btn-outline">了解更多</button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default XLindex;
